import React, { useState } from 'react';
import '../../styles/faq/faq.scss';
import faqData from '../../data/faq.json';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = index => {
      setActiveIndex(activeIndex === index ? null : index);
    };

    return (
      <div id='faq-layout'>
        <h1 id='faq-title'>Frequently Asked Questions</h1>
        <div className='faq-container'>
          {faqData.map((faq, index) => (
            <div key={index} className='faq-item'>
              <div
                className='faq-question'
                onClick={() => toggleFAQ(index)}
              >
                <p className='faq-text'>{faq.question}</p>
                <span className='faq-toggle'>{activeIndex === index ? '\u2212' : '+'}</span>
              </div>
              <div
                className={`faq-answer ${activeIndex === index ? 'active' : ''}`}
              >
                {faq.answer}
              </div>
              {index !== faqData.length - 1 && <hr />}
            </div>
          ))}
        </div>
      </div>
    );
  };

  export default FAQ;
